import { createStructuredSelector } from "reselect";
import {
    UNSPSC_FAMILY_LIST,
    UNSPSC_FAMILY_LIST_SUCCESS,
    UNSPSC_FAMILY_LIST_ERROR,
    UNSPSC_FAMILY_PAGE_SET,
    UNSPSC_FAMILY_HEADER,
    UNSPSC_FAMILY_SEARCH_SET,
    UNSPSC_FAMILY_SEARCH_CHANGE,
    UNSPSC_FAMILY_ADD_SET,
    UNSPSC_FAMILY_ADD_MODAL_SET,
    UNSPSC_FAMILY_ADD,
    UNSPSC_FAMILY_ADD_SUCCESS,
    UNSPSC_FAMILY_ADD_ERROR,
    UNSPSC_FAMILY_ADD_CHANGE,
    UNSPSC_FAMILY_EDIT_SET,
    UNSPSC_FAMILY_EDIT_CHANGE,
    UNSPSC_FAMILY_EDIT_MODAL_SET,
    UNSPSC_FAMILY_DETAIL,
    UNSPSC_FAMILY_DETAIL_SUCCESS,
    UNSPSC_FAMILY_DETAIL_ERROR,
    UNSPSC_FAMILY_UPDATE,
    UNSPSC_FAMILY_UPDATE_SUCCESS,
    UNSPSC_FAMILY_UPDATE_ERROR
} from "../actions";

export const NAME = 'unspscFamily';

export const UnspscFamilyList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: UNSPSC_FAMILY_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const UnspscFamilyListSuccess = (data) => ({
    type: UNSPSC_FAMILY_LIST_SUCCESS,
    payload: data
});

export const UnspscFamilyListError = (error) => ({
    type: UNSPSC_FAMILY_LIST_ERROR,
    payload: error
});

export const UnspscFamilyPageSet = (data) => ({
    type: UNSPSC_FAMILY_PAGE_SET,
    payload: data
});

export const UnspscFamilyHeader = (data) => ({
    type: UNSPSC_FAMILY_HEADER,
    payload: data
})

export const UnspscFamilySearchSet = (data) => ({
    type: UNSPSC_FAMILY_SEARCH_SET,
    payload: data
});

export const UnspscFamilySearchChangeSet = (data) => ({
    type: UNSPSC_FAMILY_SEARCH_CHANGE,
    payload: data
});


export const UnspscFamilyAddChangeSet = (data) => ({
    type: UNSPSC_FAMILY_ADD_CHANGE,
    payload: data
});

export const UnspscFamilyAddSet = (data) => ({
    type: UNSPSC_FAMILY_ADD_SET,
    payload: data
});

export const UnspscFamilyAddModalSet = (data) => ({
    type: UNSPSC_FAMILY_ADD_MODAL_SET,
    payload: data
});

export const UnspscFamilyAdd = (data) => ({
    type: UNSPSC_FAMILY_ADD,
    payload: data
});

export const UnspscFamilyAddSuccess = (message) => ({
    type: UNSPSC_FAMILY_ADD_SUCCESS,
    payload: message
});

export const UnspscFamilyAddError = (error) => ({
    type: UNSPSC_FAMILY_ADD_ERROR,
    payload: error
});

export const UnspscFamilyEditSet = (data) => ({
    type: UNSPSC_FAMILY_EDIT_SET,
    payload: data
});

export const UnspscFamilyEditChangeSet = (data) => ({
    type: UNSPSC_FAMILY_EDIT_CHANGE,
    payload: data
});

export const UnspscFamilyEditModalSet = (data) => ({
    type: UNSPSC_FAMILY_EDIT_MODAL_SET,
    payload: data
});

export const UnspscFamilyEditTabSet = (data) => ({
    type: UNSPSC_FAMILY_EDIT_TAB_SET,
    payload: data
});

export const UnspscFamilyDetail = (data) => ({
    type: UNSPSC_FAMILY_DETAIL,
    payload: data
});

export const UnspscFamilyDetailSuccess = (data) => ({
    type: UNSPSC_FAMILY_DETAIL_SUCCESS,
    payload: data
});

export const UnspscFamilyDetailError = (error) => ({
    type: UNSPSC_FAMILY_DETAIL_ERROR,
    payload: error
});

export const UnspscFamilyUpdate = (data) => ({
    type: UNSPSC_FAMILY_UPDATE,
    payload: data
});

export const UnspscFamilyUpdateSuccess = (message) => ({
    type: UNSPSC_FAMILY_UPDATE_SUCCESS,
    payload: message
});

export const UnspscFamilyUpdateError = (error) => ({
    type: UNSPSC_FAMILY_UPDATE_ERROR,
    payload: error
});



const unspscFamily = (state) => state[NAME];

export const UnspscFamilySelector = createStructuredSelector({
    unspscFamily
})
